import React, { useState } from 'react';
import { CalendarIcon, MailIcon, DatabaseIcon, SlackIcon, LinkedinIcon, CheckCircleIcon, RefreshCwIcon, AlertCircleIcon, ChevronRightIcon, LockIcon } from 'lucide-react';
export function DataSourceConnections({
  data,
  updateData
}) {
  const [connecting, setConnecting] = useState('');
  const dataSources = [{
    id: 'googleCalendar',
    name: 'Google Calendar',
    icon: <CalendarIcon className="h-5 w-5" data-id="element-568" />,
    description: 'Access your calendar events for meeting preparation',
    required: true,
    premium: false
  }, {
    id: 'gmail',
    name: 'Gmail',
    icon: <MailIcon className="h-5 w-5" data-id="element-569" />,
    description: 'Analyze relevant email threads for context',
    required: false,
    premium: false
  }, {
    id: 'salesforce',
    name: 'Salesforce',
    icon: <DatabaseIcon className="h-5 w-5" data-id="element-570" />,
    description: 'Pull account and opportunity data for deeper insights',
    required: false,
    premium: true
  }, {
    id: 'hubspot',
    name: 'HubSpot',
    icon: <DatabaseIcon className="h-5 w-5" data-id="element-571" />,
    description: 'Sync contact and deal information',
    required: false,
    premium: true
  }, {
    id: 'slack',
    name: 'Slack',
    icon: <SlackIcon className="h-5 w-5" data-id="element-572" />,
    description: 'Analyze relevant conversations and channels',
    required: false,
    premium: true
  }, {
    id: 'linkedin',
    name: 'LinkedIn',
    icon: <LinkedinIcon className="h-5 w-5" data-id="element-573" />,
    description: 'Access professional profiles and company updates',
    required: false,
    premium: true
  }];
  const connectSource = sourceId => {
    setConnecting(sourceId);
    // Simulate connection process
    setTimeout(() => {
      const updatedSources = {
        ...data.connectedSources,
        [sourceId]: true
      };
      updateData('connectedSources', updatedSources);
      setConnecting('');
    }, 1500);
  };
  const disconnectSource = sourceId => {
    const updatedSources = {
      ...data.connectedSources,
      [sourceId]: false
    };
    updateData('connectedSources', updatedSources);
  };
  return <div data-id="element-574">
      <h2 className="text-2xl font-bold mb-2" data-id="element-575">Connect Your Data Sources</h2>
      <p className="text-[#F5F7FA] text-opacity-70 mb-6" data-id="element-576">
        Connect your data sources to enhance your meeting briefs with relevant
        context and insights.
      </p>
      <div className="space-y-4" data-id="element-577">
        {dataSources.map(source => <div key={source.id} className={`flex items-center justify-between p-4 border rounded-lg ${source.premium && !data.connectedSources[source.id] ? 'border-[#F5F7FA] border-opacity-10 bg-[#1E2A38]' : data.connectedSources[source.id] ? 'border-green-500 bg-green-500 bg-opacity-5' : 'border-[#F5F7FA] border-opacity-10 bg-[#1E2A38]'}`} data-id="element-578">
            <div className="flex items-center" data-id="element-579">
              <div className={`p-2 rounded-lg mr-3 ${data.connectedSources[source.id] ? 'bg-green-500 bg-opacity-20 text-green-500' : 'bg-[#F5F7FA] bg-opacity-10 text-[#F5F7FA]'}`} data-id="element-580">
                {source.icon}
              </div>
              <div data-id="element-581">
                <div className="flex items-center" data-id="element-582">
                  <h3 className="font-medium" data-id="element-583">{source.name}</h3>
                  {source.required && <span className="ml-2 text-xs bg-[#3B82F6] bg-opacity-20 text-[#3B82F6] px-2 py-0.5 rounded" data-id="element-584">
                      Required
                    </span>}
                  {source.premium && !data.connectedSources[source.id] && <span className="ml-2 text-xs bg-[#C8F169] bg-opacity-20 text-[#C8F169] px-2 py-0.5 rounded flex items-center" data-id="element-585">
                      <LockIcon className="h-3 w-3 mr-1" data-id="element-586" />
                      Premium
                    </span>}
                </div>
                <p className="text-sm text-[#F5F7FA] text-opacity-70" data-id="element-587">
                  {source.description}
                </p>
              </div>
            </div>
            {data.connectedSources[source.id] ? <div className="flex items-center" data-id="element-588">
                <CheckCircleIcon className="h-5 w-5 text-green-500 mr-2" data-id="element-589" />
                <span className="text-sm text-green-500 mr-4" data-id="element-590">Connected</span>
                <button onClick={() => disconnectSource(source.id)} className="text-sm text-[#F5F7FA] text-opacity-70 hover:text-opacity-100" data-id="element-591">
                  Disconnect
                </button>
              </div> : <button onClick={() => connectSource(source.id)} disabled={connecting === source.id || source.premium && !data.connectedSources.googleCalendar} className={`px-4 py-1.5 rounded-lg transition-colors ${connecting === source.id ? 'bg-[#3B82F6] bg-opacity-50 text-white cursor-not-allowed' : source.premium && !data.connectedSources.googleCalendar ? 'bg-[#F5F7FA] bg-opacity-5 text-[#F5F7FA] text-opacity-30 cursor-not-allowed' : 'bg-[#3B82F6] hover:bg-opacity-90 text-white'}`} data-id="element-592">
                {connecting === source.id ? <div className="flex items-center" data-id="element-593">
                    <RefreshCwIcon className="h-4 w-4 mr-2 animate-spin" data-id="element-594" />
                    Connecting...
                  </div> : source.premium && !data.connectedSources.googleCalendar ? 'Connect Calendar First' : 'Connect'}
              </button>}
          </div>)}
      </div>
      {data.connectedSources.googleCalendar && !data.connectedSources.salesforce && !data.connectedSources.hubspot && <div className="mt-6 bg-[#C8F169] bg-opacity-5 border border-[#C8F169] border-opacity-20 rounded-lg p-4" data-id="element-595">
            <div className="flex items-start" data-id="element-596">
              <AlertCircleIcon className="h-5 w-5 text-[#C8F169] mt-0.5 mr-3" data-id="element-597" />
              <div data-id="element-598">
                <h4 className="font-medium text-[#C8F169] mb-1" data-id="element-599">
                  Unlock Deeper Insights
                </h4>
                <p className="text-sm text-[#F5F7FA]" data-id="element-600">
                  Connect your CRM to get enhanced meeting briefs with account
                  history, deal stages, and relationship insights.
                </p>
                <button className="mt-2 text-sm text-[#C8F169] flex items-center" data-id="element-601">
                  Upgrade to Premium
                  <ChevronRightIcon className="h-4 w-4 ml-1" data-id="element-602" />
                </button>
              </div>
            </div>
          </div>}
    </div>;
}